
import { useContext, useEffect } from "react";
import AppRouter from "./routes/AppRouter";
import { UserContext } from "./context/UserContext";
import Login from "./pages/users/Login";


const MilestonesApp = () => {

    const {user, isTokenAlive} = useContext(UserContext)
    useEffect(()=>isTokenAlive())

  return (
    <>
    {
      user.token === '' ? <Login /> : <AppRouter />
    }
    </>
  )
}

export default MilestonesApp;
